import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V = {
  '@id': string;
  '@type': 'MetricCycle';
  id: string;
  flowType: string;
  isPeriodBleeding: boolean;
};

export type V_CycleLength = {
  '@id': string;
  '@type': 'MetricCycle';
  startDate: string;
  endDate: string;
  length: number;
};

export type V_UserSub = {
  '@id': string;
  '@type': 'MetricCycle';
  id: string;
  flowType: string;
  isPeriodBleeding: boolean;
  date: string;
};

export type W = {
  flowType: string;
  isPeriodBleeding: boolean;
  date: string;
};

export function useReadCollectionCycleLengths(
  id: string,
  queryParams?: {
    'date[after]'?: string;
    'date[before]'?: string;
    'date[strictly_after]'?: string;
    'date[strictly_before]'?: string;
  },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_CycleLength>>(
    `/users/${id}/cycle-lengths${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadCollectionMetricCycle(
  id: string,
  queryParams?: {
    'date[after]'?: string;
    'date[before]'?: string;
    'date[strictly_after]'?: string;
    'date[strictly_before]'?: string;
  },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_UserSub>>(
    `/users/${id}/metric-cycle${makeQueryString(queryParams)}`,
    options,
  );
}
